import React, { useState } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { displayPrice } from '~helpers/price'
import ProductMatrix from '~components/shop/ProductMatrix'
import classNames from 'classnames'
import ProductCard from '~components/ProductCard'
import MatrixOverlay from '~components/shop/MatrixOverlay'

const Product = ({
  colours,
  product,
  listView = true,
  range
}) => {
  const [matrixOverlay, setMatrixOverlay] = useState(false)

  const displayRetailPrice = () => displayPrice(product.retail_price, 'GBP')

  const handleToggleMatrixOverlay = () => {
    setMatrixOverlay(!matrixOverlay)
    document.body.classList.toggle('overflow-y-hidden')
  }

  const mainImage = product.images.find(i => i.is_thumbnail)
  const imageSrc = mainImage && mainImage.url_standard
  const retailPrice = displayRetailPrice()

  return (
    <>
      <div className={classNames('w-1/2 px-2 my-5 md:w-1/3 lg:px-3 xl:px-5', { 'lg:w-3/12': listView }, { 'lg:w-4/12 xl:w-3/12': !listView })}>
        <ProductCard
          image={{
            src: imageSrc,
            alt: `${product.name} - ${product.custom_fields.colour}`
          }}
          title={product.name}
          subtitle={`${product.custom_fields.brand} | ${product.custom_fields.season}`}
          url={`${product.style_url}?colour=${product.custom_fields.colour_code}`}
          colour={product.custom_fields.colour}
          styleCode={product.custom_fields.style_code}
          retailPrice={retailPrice}
          onClick={handleToggleMatrixOverlay}
        />
      </div>

      {listView && (
        <div className="hidden my-5 lg:px-3 lg:w-9/12 xl:px-5 lg:block">
          <div className="overflow-x-auto">
            <ProductMatrix key={product.id} product={product} />
          </div>
        </div>
      )}
      {matrixOverlay && (
        <MatrixOverlay
          product={product}
          colours={colours}
          overlay={matrixOverlay}
          toggleOverlay={handleToggleMatrixOverlay}
          range={range}
        />
      )}
    </>
  )
}

Product.propTypes = {
  colours: PropTypes.array,
  product: PropTypes.object.isRequired,
  listView: PropTypes.bool,
  range: PropTypes.string
}

export default connect()(Product)
